import React from "react";
import "./styles/styles.css";

// Thin animated fill bar for the persons progressive-load. `active` keeps a
// shimmer running while more pages are still being fetched in the
// background; the fill itself always reflects loaded/total regardless.
const ProgressBar = ({ value, total, active }) => {
  const pct = total > 0 ? Math.min(100, Math.round((value / total) * 100)) : 0;

  return (
    <div
      className={`progress-bar-track ${active ? "progress-bar-track--active" : ""}`}
      role="progressbar"
      aria-valuenow={pct}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <div className="progress-bar-fill" style={{ width: `${pct}%` }} />
    </div>
  );
};

export default ProgressBar;
